import gsap from 'gsap';
import Sine from 'gsap';
import { handleLogo } from './handleLogo';

let activeScroll = false;
let movables = [];
const phone = 'ontouchstart' in window;
const factor = phone ? 0.2 : 0.4;

function updateOverlappingItems() {
    let shift = 0;
    for (let i = movables.length - 1; i >= 0; i--) {
      shift =
        (movables[i].position -
          movables[i].height / 2 -
          document.documentElement.scrollTop) *
        factor;
      gsap.to(movables[i].movable, { y: shift, duration: 0.8 });
    }
  }

export const setMovables = function(elements){
    if(elements){
        elements.forEach(
            element => movables.push({
                movable: element,
                height: element.offsetHeight,
                position: element.offsetTop
              })
        )
    }
}

export const handleScroll = function(event){
    event.preventDefault();
    if(activeScroll){
        updateOverlappingItems();
        handleLogo(false);
    }
}

export const setInitialPosition = function(){
    const movableTargets = movables.map(element => element.movable);
    gsap.to(movableTargets,
        {
            y:0,
            duration: 0.2,
            ease: Sine.easeInOut
        })
}

export const setActiveScroll = function (value) {
    activeScroll = value;
}